import React from 'react';
import { cn } from '@/lib/utils';

interface RateBadgeProps {
  label: string;
  elevated?: boolean;
  endTier?: boolean;
}

const RateBadge: React.FC<RateBadgeProps> = ({ label, elevated, endTier }) => (
  <span
    title={label}
    aria-label={label}
    className={cn(
      'inline-flex h-[18px] min-w-0 max-w-[10rem] sm:max-w-[14rem] items-center justify-start rounded-[0.25rem] px-2',
      'font-mono text-[10px] sm:text-[12px] font-semibold leading-none',
      endTier
        ? 'border border-primary/[0.3] bg-primary/[0.15] text-primary-text font-bold'
        : elevated
        ? 'border border-primary/[0.25] bg-primary/10 text-primary-text'
        : 'bg-[rgba(255,255,255,0.05)] text-muted-foreground/45',
    )}
  >
    <span className="block min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
      {label}
    </span>
  </span>
);

export { RateBadge };
export type { RateBadgeProps };
